module.exports = __webpack_public_path__ + "img/messages.2e8acaaa.png";